import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import { ONE_YEAR } from '../constants/FilterDateConstantValue'

const useStyles = makeStyles(theme => {
  return {
    timeRange: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    item: {
      cursor: 'pointer',
    },
    time: {
      marginBottom: 4,
      fontSize: 12,
      lineHeight: '18px',
      fontWeight: 600,
      color: '#8C8C8C',
    },
    indicator: {
      height: 3,
      background: '#DFE4EB',
    },
    active: {
      background: '#5BC959',
    },
  }
})

interface TimeRangeSelectorProps {
  data: any
  setItemActiveIndex: any
  defaultValue: string
}

const TimeRangeSelector = ({
  data,
  setItemActiveIndex,
  defaultValue,
}: TimeRangeSelectorProps) => {
  const classes = useStyles()
  const [activeTab, setActiveTab] = useState({ title: defaultValue })

  const onActiveItem = (item: any) => {
    setActiveTab(item)
    setItemActiveIndex(item)
  }

  return (
    <div className={classes.timeRange}>
      {data.map((item: any, index: any) => (
        <div
          key={item.title}
          className={classes.item}
          style={{ width: `calc(100% / ${data.length} - 4px)` }}
          onClick={() => onActiveItem(item)}
        >
          <div className={classes.time}>{item.title}</div>
          <div
            className={`${classes.indicator} ${
              JSON.stringify(item) === JSON.stringify(activeTab)
                ? classes.active
                : ''
            }`}
          />
        </div>
      ))}
    </div>
  )
}

export default TimeRangeSelector
